export const FPS_MCC = '0000';
export const FPS_CURRENCY = '344';
export const FPS_ID = '3601861';
export const MERCHANT_NAME = 'Assicurazioni Generali S.';
